import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import { Link } from "react-router-dom";
import { getDetailDayFolios } from "../services/companyAPI";
import LoadingComponent from "../../widgets/LoadingComponent";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { exportToExcel } from "react-json-to-excel";
import { FaDownload, FaFilePdf, FaArrowLeft } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyDocument from "../../administration/reporte/GeneraPdf";

const HeaderCell = styled(TableCell)(() => ({
  backgroundColor: '#224B6A', color: '#fff', fontWeight: 'bold',
  fontSize: '0.78rem', whiteSpace: 'nowrap', padding: '10px 12px',
}));

const BodyCell = styled(TableCell)(() => ({
  fontSize: '0.78rem', padding: '7px 12px', borderColor: '#dee2e6',
}));

const StyledRow = styled(TableRow)(({ index }) => ({
  backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc',
  '&:hover': { backgroundColor: 'rgba(144, 203, 216, 0.2)' },
}));

const DetallePlanModal = ({
  openDetalleFolios = false,
  setOpenDetalleFolios = () => { },
  emissionPlanPerMonth = [],
  selectedPlanDetail = {},
  Nit = '',
  NameCompany = ''
}) => {
  const [DetalleDiaFolio, setDetalleDiaFolio] = useState(false);
  const [diaFoliosInfo, setDiasFoliosInfo] = useState([]);
  const [Loading, setLoading] = useState(false);

  const companyPlanId = emissionPlanPerMonth?.companyPlanId;

  const getDetailDayFoliosFunc = async (planMes) => {
    const { anio, mes, companyId } = planMes;
    const result = await getDetailDayFolios(
      companyId,
      mes,
      anio,
      companyPlanId
    );
    setDiasFoliosInfo(result.generalResult);
    return result;
  };

  const openDetailDayFolios = async (planMes) => {
    setLoading(true);
    await getDetailDayFoliosFunc(planMes);
    setLoading(false);
    setDetalleDiaFolio(true);
  };

  const closeModal = () => {
    setDetalleDiaFolio(false);
    setOpenDetalleFolios(false);
  };

  const descargarExcelAnioMes = () => {
    const value = emissionPlanPerMonth.generalResult;
    if (value.length === 0) {
      alert("No hay datos para descargar");
      return;
    }
    exportToExcel(value, "EmisionesAnioMes");
  };

  const descargarExcelMesDias = () => {
    const value = diaFoliosInfo;
    if (value.length === 0) {
      alert("No hay datos para descargar");
      return;
    }
    exportToExcel(value, "EmisionesMesDias");
  };

  const planTitle = `${selectedPlanDetail?.plan} - ${selectedPlanDetail?.esPadre ? "(Padre)" : "(Extensión)"}`;

  return (
    <Dialog
      open={openDetalleFolios}
      onClose={closeModal}
      fullWidth
      maxWidth={"md"}
    >
      {<LoadingComponent Loading={Loading} canClose={false} />}

      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
        <Typography sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
          {planTitle}
        </Typography>
        <IconButton size="small" onClick={closeModal} sx={{ color: '#fff' }}>
          <MdClose />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 2 }}>
        {DetalleDiaFolio ? (
          <Grid container direction={"column"} gap={"1rem"}>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                startIcon={<FaArrowLeft size={12} />}
                onClick={() => setDetalleDiaFolio(false)}
                sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}
              >
                Volver
              </Button>
            </Grid>
            <Grid item>
              <Typography
                textAlign={"center"}
                fontWeight={"bold"}
                variant="h6"
                my={3}
              >
                Detalle folios consumidos en el mes
              </Typography>

              <Box sx={{ textAlign: 'right', mb: 1 }}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<FaDownload size={12} />}
                  onClick={descargarExcelMesDias}
                  title="Descargar a Excel Emisiones Mes por días"
                  sx={{ fontSize: '0.78rem' }}
                >
                  Excel
                </Button>
              </Box>

              <TableContainer component={Paper} variant="outlined">
                <Table sx={{ minWidth: 650 }} aria-label="detalle dia folios">
                  <TableHead>
                    <TableRow>
                      <HeaderCell align="center">Día fecha</HeaderCell>
                      <HeaderCell align="center">Total Día</HeaderCell>
                      <HeaderCell align="center">Total Mes</HeaderCell>
                      <HeaderCell align="center">Kardex</HeaderCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {diaFoliosInfo?.length &&
                      diaFoliosInfo.map((row, index) => (
                        <StyledRow key={row.name} index={index}>
                          <BodyCell align="center">
                            {moment(row.dia).format("L")}
                          </BodyCell>
                          <BodyCell align="center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={row.totalDia}
                            />
                          </BodyCell>
                          <BodyCell align="center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={row.kardexMes}
                            />
                          </BodyCell>
                          <BodyCell align="center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={row.kardexGeneral}
                            />
                          </BodyCell>
                        </StyledRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={"1rem"}
          >
            {/* Info panel */}
            <Paper
              variant="outlined"
              sx={{ width: '100%', borderRadius: 2, p: 2, mt: 1 }}
            >
              <Grid container spacing={1}>
                {/* Left column */}
                <Grid item xs={12} md={6}>
                  {[
                    {
                      label: 'Fecha Inicio Contratado:',
                      value: moment(selectedPlanDetail?.fechaInicio).format("LL"),
                    },
                    {
                      label: 'Fecha Fin Consumo:',
                      value: selectedPlanDetail.finRenovacion
                        ? moment(selectedPlanDetail.finRenovacion).format("LL")
                        : "N/A",
                    },
                    {
                      label: 'Factura Asignada:',
                      value: `${selectedPlanDetail?.facturaPrefijo} - ${selectedPlanDetail.facturaNumero}`,
                    },
                    {
                      label: `Valor ${selectedPlanDetail.pagoAnual ? "Anual:" : "Mensual:"}`,
                      value: (
                        <>
                          $<NumericFormat
                            displayType="text"
                            thousandSeparator=","
                            value={selectedPlanDetail?.valorAnual}
                          />
                        </>
                      ),
                    },
                    {
                      label: 'Fecha de factura:',
                      value: moment(selectedPlanDetail?.facturaFecha).format("LL"),
                    },
                  ].map(({ label, value }) => (
                    <Box key={label} sx={{ display: 'flex', gap: 1, mb: 0.75, flexWrap: 'wrap' }}>
                      <Typography sx={{ fontSize: '0.78rem', fontWeight: 'bold' }}>{label}</Typography>
                      <Typography sx={{ fontSize: '0.78rem' }}>{value}</Typography>
                    </Box>
                  ))}
                </Grid>

                {/* Right column */}
                <Grid item xs={12} md={6}>
                  {[
                    {
                      label: 'Fecha Fin Contratado:',
                      value: moment(selectedPlanDetail?.fechaFin).format("LL"),
                    },
                    {
                      label: 'Folios consumidos:',
                      value: (
                        <NumericFormat
                          displayType="text"
                          thousandSeparator=","
                          value={selectedPlanDetail?.foliosConsumidos}
                        />
                      ),
                    },
                    {
                      label: 'Tipo De Pago:',
                      value: selectedPlanDetail.pagoAnual ? "Anual" : "Mensual",
                    },
                    {
                      label: 'Plan Activo:',
                      value: selectedPlanDetail.estado ? "Si" : "No",
                    },
                  ].map(({ label, value }) => (
                    <Box key={label} sx={{ display: 'flex', gap: 1, mb: 0.75, flexWrap: 'wrap' }}>
                      <Typography sx={{ fontSize: '0.78rem', fontWeight: 'bold' }}>{label}</Typography>
                      <Typography sx={{ fontSize: '0.78rem' }}>{value}</Typography>
                    </Box>
                  ))}
                </Grid>

                {/* Observation row */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Typography sx={{ fontSize: '0.78rem', fontWeight: 'bold' }}>Observación:</Typography>
                    <Typography sx={{ fontSize: '0.78rem' }}>{selectedPlanDetail?.observacion}</Typography>
                  </Box>
                </Grid>

                {/* Download button */}
                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<FaDownload size={12} />}
                    onClick={descargarExcelAnioMes}
                    title="Descargar a Excel Emisiones Año por Mes"
                    sx={{ fontSize: '0.78rem' }}
                  >
                    Excel
                  </Button>
                </Grid>
              </Grid>
            </Paper>

            {/* Month table */}
            <Paper variant="outlined" sx={{ width: '100%', borderRadius: 2, p: 2 }}>
              <Typography textAlign={"center"} fontWeight={"bold"} mb={2} sx={{ fontSize: '0.9rem' }}>
                Detalle folios
              </Typography>

              <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="detalle folios mes">
                  <TableHead>
                    <TableRow>
                      <HeaderCell align="center">Año</HeaderCell>
                      <HeaderCell align="center">Mes</HeaderCell>
                      <HeaderCell align="center">Total</HeaderCell>
                      <HeaderCell align="center">Kardex</HeaderCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {emissionPlanPerMonth.generalResult?.length &&
                      emissionPlanPerMonth.generalResult.map((row, index) => (
                        <StyledRow key={row.name} index={index}>
                          <BodyCell align="center">{row.anio}</BodyCell>
                          <BodyCell align="center">
                            <Link onClick={() => openDetailDayFolios(row)}>
                              {moment().month(row.mes - 1).format("MMMM")}
                            </Link>
                          </BodyCell>
                          <BodyCell align="center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={row.total}
                            />
                          </BodyCell>
                          <BodyCell align="center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={row.kardex}
                            />
                          </BodyCell>
                        </StyledRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DetallePlanModal;
